export enum NotificationType {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  INFO = 'INFO',
  OK = 'OK'
}

export interface NotificationDTO {
  entityId: number
  entityTitle: string
  entityType: string
  message: string
  notificationType: NotificationType
  userIds: number[]
}

export type NotificationTypeDTO =  {
  [key in NotificationType]?: number;
}